var _path, _path2, _g, _path3, _path4, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 8.09328C7.17963 9.25452 5.90782 10 4.48 10C2.00576 10 0 7.76142 0 5C0 2.23858 2.00576 0 4.48 0C5.90782 0 7.17963 0.74548 8 1.90672C8.82038 0.74548 10.0922 0 11.52 0C13.9942 0 16 2.23858 16 5C16 7.76142 13.9942 10 11.52 10C10.0922 10 8.82038 9.25452 8 8.09328Z",
    fill: "#FB5F8A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_245",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 8.09328C7.17963 9.25452 5.90782 10 4.48 10C2.00576 10 0 7.76142 0 5C0 2.23858 2.00576 0 4.48 0C5.90782 0 7.17963 0.74548 8 1.90672C8.82038 0.74548 10.0922 0 11.52 0C13.9942 0 16 2.23858 16 5C16 7.76142 13.9942 10 11.52 10C10.0922 10 8.82038 9.25452 8 8.09328Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_245)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#FC719F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#ED5267"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14C10.7614 14 16 9 16 5C16 5 0 5 0 5C0 9 5.23858 14 8 14Z",
    fill: "#FB5F8A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_245",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 5,
    width: 16,
    height: 9
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14C10.7614 14 16 9 16 5C16 5 0 5 0 5C0 9 5.23858 14 8 14Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_245)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#FC719F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#ED5267"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHartIcon);
export default __webpack_public_path__ + "static/media/hart-icon.5415f72b642277a61f4776a215849253.svg";
export { ForwardRef as ReactComponent };